<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="list-box">
      <img src="../assets/img-1.png" alt="">
    </div>

    <div class="about-box">
      <div class="title">{{ $t('home_1') }}</div>
      <div class="sbtitle">{{ $t('home_2') }}</div>
      <div class="img-list-box">
        <img src="../assets/img-2.png" alt="">
        <img src="../assets/img-3.png" alt="">
        <img src="../assets/img-4.png" alt="">
        <img src="../assets/img-5.png" alt="">
      </div>
    </div>

    <div class="news-box">
      <div class="title">{{ $t('home_3') }}</div>
      <div class="sbtitle">{{ $t('home_4') }}</div>
      <div class="new-list">
        <div class="new-item">
          <img src="../assets/img-11.png" alt="">
          <div class="new-text-1">{{ $t('home_5') }}</div>
          <div class="new-text-2">{{ $t('home_6') }}</div>
          <div class="new-text-3">$10.49 - $1,000</div>
          <div class="new-btn">Buy Now</div>
        </div>
        <div class="new-item">
          <img src="../assets/img-6.png" alt="">
          <div class="new-text-1">{{ $t('home_7') }}</div>
          <div class="new-text-2">{{ $t('home_8') }}</div>
          <div class="new-text-3">$10.49 - $1,000</div>
          <div class="new-btn">Buy Now</div>
        </div>
        <div class="new-item">
          <img src="../assets/img-7.png" alt="">
          <div class="new-text-1">{{ $t('home_9') }}</div>
          <div class="new-text-2">{{ $t('home_10') }}</div>
          <div class="new-text-3">$10.49 - $1,000</div>
          <div class="new-btn">Buy Now</div>
        </div>
        <div class="new-item">
          <img src="../assets/img-8.png" alt="">
          <div class="new-text-1">{{ $t('home_11') }}</div>
          <div class="new-text-2">{{ $t('home_12') }}</div>
          <div class="new-text-3">$10.49 - $1,000</div>
          <div class="new-btn">Buy Now</div>
        </div>
        <div class="new-item">
          <img src="../assets/img-9.png" alt="">
          <div class="new-text-1">{{ $t('home_13') }}</div>
          <div class="new-text-2">{{ $t('home_14') }}</div>
          <div class="new-text-3">$10.49 - $1,000</div>
          <div class="new-btn">Buy Now</div>
        </div>
        <div class="new-item">
          <img src="../assets/img-10.png" alt="">
          <div class="new-text-1">{{ $t('home_15') }}</div>
          <div class="new-text-2">{{ $t('home_16') }}</div>
          <div class="new-text-3">$10.49 - $1,000</div>
          <div class="new-btn">Buy Now</div>
        </div>
      </div>
    </div>

    <div class="sign-box">
      <div class="sign-text">Sign Up To Our Newsletter</div>
      <div class="sign-input">
        <input type="text" class="input-box" placeholder="Type your Email address">
        <div class="sign-btn">Subscribe</div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="less" scoped>
.title {
  color: #E51359;
  text-align: center;
  font-family: Helvetica;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;
}

.sbtitle {
  color: #333;
  text-align: center;
  font-family: Helvetica;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: capitalize;
  margin-top: 32px;
}

.list-box {
  width: 100%;
  padding: 80px 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 800px;
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;
  }
}

.about-box {
  margin-top: 120px;


  .img-list-box {
    display: flex;
    padding: 57px 100px;
    align-items: center;
    justify-content: space-between;

    img {
      width: 400px;
      height: 222px;
      flex-shrink: 0;
      border-radius: 40px;
    }
  }
}

.news-box {
  padding: 100px 120px;

  .new-list {
    padding: 120px 121px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    .new-item {
      margin-bottom: 20px;
      width: 400px;

      img {
        width: 400px;
        border-radius: 20px;
      }

      .new-text-1 {
        color: #333;
        font-family: Helvetica;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin-top: 20px;
      }

      .new-text-2 {
        color: #333;
        font-family: Helvetica;
        font-size: 18px;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
        text-transform: capitalize;
        margin-top: 23px;
      }

      .new-text-3 {
        color: #E51359;
        font-family: Helvetica;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin-top: 10px;
      }

      .new-btn {
        width: 115px;
        height: 45px;
        flex-shrink: 0;
        background-color: #E51359;
        line-height: 45px;
        text-align: center;
        margin-top: 30px;
        color: #fff;
        border-radius: 10px;
      }
    }
  }
}

.sign-box {
  background: #78D6E8;
  padding: 80px 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .sign-text {
    color: #FFF;
    font-family: Helvetica;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
  }

  .sign-input {
    width: 630px;
    height: 62px;
    flex-shrink: 0;
    border-radius: 31px;
    background: #FFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    .sign-btn {
      width: 214px;
      height: 62px;
      flex-shrink: 0;
      border-radius: 31px;
      background: #E51359;
      line-height: 62px;
      text-align: center;
      color: #FFF;
      text-align: center;
      font-family: Helvetica;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      text-transform: capitalize;
    }

    .input-box {
      padding: 0px 25px;
      height: 100%;
    }
  }
}
</style>
